import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { GET_PLAYBACK } from "@/apollo/queries/playback";
import { useAuthUserQuery, useDeviceInfoQuery, usePlaybackSessionCloseMutation, usePlaybackSessionOpenMutation } from "@/hooks";
import AreaCheckAPI from "@/lib/AreaCheckAPI";
import { rightsControlType, userRating } from "@/lib/constants";
import dayjs from "@/lib/day";
import { AdultNotViewableError, GEOLOCATION_ERROR_CODES, GEOLOCATION_ERROR_MESSAGES, GEOLOCATION_ERROR_MESSAGES_ANDROID, GEOLOCATION_ERROR_MESSAGES_IOS, GeoLocationError, PREPARE_TO_PLAY_OVERLAY_CODES, PlaybackError, PlaybackSessionError, PrepareToPlayOverlay, WATCH_ERROR_CODES, WATCH_ERROR_MESSAGES } from "@/lib/errors";
import getVisitorId from "@/lib/getVisitorId";
import maybeIOS from "@/lib/maybeIOS";
import { useApolloClient } from "@apollo/client";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useReducer, useRef } from "react";

function checkMobileDevice(_x, _x2) {
  return _checkMobileDevice.apply(this, arguments);
}

function _checkMobileDevice() {
  _checkMobileDevice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(deviceInfo, adultFlag) {
    var _deviceInfo$os;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(deviceInfo !== null && deviceInfo !== void 0 && deviceInfo.isAndroid)) {
              _context5.next = 4;
              break;
            }

            throw new PrepareToPlayOverlay(null, PREPARE_TO_PLAY_OVERLAY_CODES["appkick"]);

          case 4:
            if (!(deviceInfo !== null && deviceInfo !== void 0 && deviceInfo.isIOS && (deviceInfo === null || deviceInfo === void 0 ? void 0 : (_deviceInfo$os = deviceInfo.os) === null || _deviceInfo$os === void 0 ? void 0 : _deviceInfo$os.version) < 11.2)) {
              _context5.next = 10;
              break;
            }

            if (!adultFlag) {
              _context5.next = 9;
              break;
            }

            throw new AdultNotViewableError();

          case 9:
            throw new PrepareToPlayOverlay(null, PREPARE_TO_PLAY_OVERLAY_CODES["appkick"]);

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _checkMobileDevice.apply(this, arguments);
}

function checkMember(_x3, _x4) {
  return _checkMember.apply(this, arguments);
}

function _checkMember() {
  _checkMember = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(user, meta) {
    var code;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!(rightsControlType[meta.rights_control_type] > rightsControlType.free && !user)) {
              _context6.next = 3;
              break;
            }

            code = function () {
              switch (rightsControlType[meta.rights_control_type]) {
                case rightsControlType.member_only:
                  return PREPARE_TO_PLAY_OVERLAY_CODES["needlogin"];

                case rightsControlType.entitled_only:
                  return PREPARE_TO_PLAY_OVERLAY_CODES["needlogin_and_contract"];
              }
            }();

            throw new PrepareToPlayOverlay(null, code);

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _checkMember.apply(this, arguments);
}

function checkAgeRestriction(_x5, _x6) {
  return _checkAgeRestriction.apply(this, arguments);
}

function _checkAgeRestriction() {
  _checkAgeRestriction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(user, meta) {
    var _user$currentProfile, permitRating;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (!(user && user !== null && user !== void 0 && user.currentProfile)) {
              _context7.next = 4;
              break;
            }

            permitRating = userRating[user === null || user === void 0 ? void 0 : (_user$currentProfile = user.currentProfile) === null || _user$currentProfile === void 0 ? void 0 : _user$currentProfile.rating].permitRating;

            if (permitRating.includes(meta.rating)) {
              _context7.next = 4;
              break;
            }

            throw new PrepareToPlayOverlay(null, PREPARE_TO_PLAY_OVERLAY_CODES["rating"]);

          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _checkAgeRestriction.apply(this, arguments);
}

function checkPlaybackError(_x7) {
  return _checkPlaybackError.apply(this, arguments);
}

function _checkPlaybackError() {
  _checkPlaybackError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(playback) {
    var _playback$error, _playback$error2, code, message;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!(playback !== null && playback !== void 0 && playback.error)) {
              _context8.next = 4;
              break;
            }

            code = playback === null || playback === void 0 ? void 0 : (_playback$error = playback.error) === null || _playback$error === void 0 ? void 0 : _playback$error.code;
            message = playback === null || playback === void 0 ? void 0 : (_playback$error2 = playback.error) === null || _playback$error2 === void 0 ? void 0 : _playback$error2.message;
            throw new PlaybackError(message, code);

          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _checkPlaybackError.apply(this, arguments);
}

var GEOLOCATION_ACCURACY_LIMIT = 5000;
var GEOLOCATION_TIMEOUT = 30000;

function checkArea(_x8, _x9, _x10) {
  return _checkArea.apply(this, arguments);
}

function _checkArea() {
  _checkArea = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(user, meta, deviceInfo) {
    var _user$currentProfile2, areaCheck, code;

    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            if (!meta.area_control_flag) {
              _context10.next = 8;
              break;
            }

            if (!window.navigator.geolocation) {
              _context10.next = 6;
              break;
            }

            areaCheck = new AreaCheckAPI(user === null || user === void 0 ? void 0 : (_user$currentProfile2 = user.currentProfile) === null || _user$currentProfile2 === void 0 ? void 0 : _user$currentProfile2.uuid);
            return _context10.abrupt("return", new Promise(function (resolve, reject) {
              var watchId = window.navigator.geolocation.watchPosition( /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(pos) {
                  var _pos$coords, latitude, longitude, accuracy, res, ok, json, message;

                  return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          _pos$coords = pos.coords, latitude = _pos$coords.latitude, longitude = _pos$coords.longitude, accuracy = _pos$coords.accuracy;

                          if (!(accuracy < GEOLOCATION_ACCURACY_LIMIT)) {
                            _context9.next = 9;
                            break;
                          }

                          window.navigator.geolocation.clearWatch(watchId);
                          clearTimeout(watchTimeoutId);
                          _context9.next = 6;
                          return areaCheck.check(latitude, longitude);

                        case 6:
                          res = _context9.sent;
                          ok = res.ok, json = res.json;

                          if (json.result) {
                            resolve();
                          } else {
                            if (ok) {
                              message = json.reason.message;
                            } else {
                              message = WATCH_ERROR_MESSAGES[WATCH_ERROR_CODES["episode_not_viewable"]];
                            }

                            reject(new GeoLocationError(message, json.reason.code));
                          }

                        case 9:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9);
                }));

                return function (_x24) {
                  return _ref6.apply(this, arguments);
                };
              }(), function (err) {
                window.navigator.geolocation.clearWatch(watchId);
                clearTimeout(watchTimeoutId); // PositionError.code
                // 1: PERMISSION_DENIED
                // 2: POSITION_UNAVAILABLE
                // 3: TIMEOUT

                var MESSAGES = function () {
                  if (deviceInfo !== null && deviceInfo !== void 0 && deviceInfo.isIOS) {
                    return GEOLOCATION_ERROR_MESSAGES_IOS;
                  }

                  if (deviceInfo !== null && deviceInfo !== void 0 && deviceInfo.isAndroid) {
                    return GEOLOCATION_ERROR_MESSAGES_ANDROID;
                  }

                  return GEOLOCATION_ERROR_MESSAGES;
                }();

                var code = err.code ? Number(err.code) : 99;
                var message = MESSAGES[code];
                reject(new GeoLocationError(message, code));
              }, {
                enableHighAccuracy: true,
                maximumAge: 0
              });
              var watchTimeoutId = setTimeout(function () {
                window.navigator.geolocation.clearWatch(watchId); // タイムアウトエラー
                // 位置情報の取得がタイムアウトしました。ご利用状況をご確認の上、しばらく経ってから電波の良い場所でご利用ください。

                var code = GEOLOCATION_ERROR_CODES["geolocation_timeout"];
                reject(new GeoLocationError(null, code));
              }, GEOLOCATION_TIMEOUT);
            }));

          case 6:
            code = GEOLOCATION_ERROR_CODES["geolocation_unusable"];
            throw new GeoLocationError(null, code);

          case 8:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _checkArea.apply(this, arguments);
}

function checkResume(_x11, _x12, _x13, _x14, _x15) {
  return _checkResume.apply(this, arguments);
}

function _checkResume() {
  _checkResume = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(resumePoint, playback, liveResumeFlag, updateResumePoint, resumepoint) {
    var liveResumePoint;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            if (!liveResumeFlag) {
              _context11.next = 6;
              break;
            }

            // ダイアログを出さない
            // 再生位置を前回視聴時の視聴位置に調整
            liveResumePoint = playback.resumePoint || resumepoint;
            updateResumePoint(liveResumePoint);
            return _context11.abrupt("return");

          case 6:
            if (!(resumePoint == null && playback.resumePoint > 0)) {
              _context11.next = 8;
              break;
            }

            throw new PrepareToPlayOverlay(null, PREPARE_TO_PLAY_OVERLAY_CODES["resume"]);

          case 8:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _checkResume.apply(this, arguments);
}

function checkLiveBefore(_x16) {
  return _checkLiveBefore.apply(this, arguments);
}

function _checkLiveBefore() {
  _checkLiveBefore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(meta) {
    var now, encodeStart;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            if (!meta.is_live) {
              _context12.next = 5;
              break;
            }

            now = dayjs();
            encodeStart = dayjs(new Date(meta.encode_start_date));

            if (!(meta.encode_start_date && now.isBefore(encodeStart))) {
              _context12.next = 5;
              break;
            }

            throw new PrepareToPlayOverlay(null, PREPARE_TO_PLAY_OVERLAY_CODES["live_before"]);

          case 5:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _checkLiveBefore.apply(this, arguments);
}

function checkMobileOS(_x17, _x18, _x19) {
  return _checkMobileOS.apply(this, arguments);
}

function _checkMobileOS() {
  _checkMobileOS = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(deviceInfo, watchOnBrowserFlag, liveResumeFlag) {
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            if (!liveResumeFlag) {
              _context13.next = 4;
              break;
            }

            return _context13.abrupt("return");

          case 4:
            if (!(!watchOnBrowserFlag && maybeIOS(deviceInfo))) {
              _context13.next = 6;
              break;
            }

            throw new PrepareToPlayOverlay(null, PREPARE_TO_PLAY_OVERLAY_CODES["suggest_app"]);

          case 6:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _checkMobileOS.apply(this, arguments);
}

function checkUseEntitlement(_x20, _x21) {
  return _checkUseEntitlement.apply(this, arguments);
}

function _checkUseEntitlement() {
  _checkUseEntitlement = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(confirmed, entitlements) {
    var filterd;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            if (!confirmed) {
              _context14.next = 2;
              break;
            }

            return _context14.abrupt("return");

          case 2:
            // playback/authで権利が行使されるため、playbackAuthをコールする前に確認をださないといけない
            // 行使対象の権利にexercise_durationがあって、exercised_atがない場合は行使前
            filterd = entitlements.find(function (entitlement) {
              return entitlement.exercise_duration && !entitlement.exercised_at;
            });

            if (!filterd) {
              _context14.next = 5;
              break;
            }

            throw new PrepareToPlayOverlay(null, PREPARE_TO_PLAY_OVERLAY_CODES["entitlement_confirm"]);

          case 5:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _checkUseEntitlement.apply(this, arguments);
}

function checkDVRLive(_x22, _x23) {
  return _checkDVRLive.apply(this, arguments);
} //metaにはepisode, entitlementにはhowtoplayが入る


function _checkDVRLive() {
  _checkDVRLive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(meta, resumePoint) {
    var now, encodeStart, encodeEnd, isOnair;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            if (!(meta.is_live && meta.start_over_flag)) {
              _context15.next = 7;
              break;
            }

            now = dayjs();
            encodeStart = dayjs(new Date(meta.encode_start_date));
            encodeEnd = dayjs(new Date(meta.encode_end_date));

            isOnair = function () {
              if (meta.encode_start_date && meta.encode_end_date) {
                return now.isBetween(encodeStart, encodeEnd, null, "[)");
              } else if (meta.encode_start_date && !meta.encode_end_date) {
                return now.isSameOrAfter(encodeStart);
              } else if (!meta.encode_start_date && meta.encode_end_date) {
                return now.isBefore(encodeEnd);
              }
            }();

            if (!(isOnair && resumePoint === null)) {
              _context15.next = 7;
              break;
            }

            throw new PrepareToPlayOverlay(null, PREPARE_TO_PLAY_OVERLAY_CODES["dvr_live"]);

          case 7:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _checkDVRLive.apply(this, arguments);
}

export function usePrepareToPlay(meta, entitlements) {
  var _router$query, _router$query2, _playbackAuth$current2, _playbackAuth$current9;

  var router = useRouter();
  var mediaSource = useRef();
  var playbackAuth = useRef();
  var liveResumeFlag = !!(router !== null && router !== void 0 && (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.liveresume);
  var resumepoint = router === null || router === void 0 ? void 0 : (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.resumepoint;
  var initialState = useMemo(function () {
    return {
      loading: true,
      prepared: false,
      // prepare処理が完了しているか
      canplay: false,
      // mediaを取得して動画再生が可能か
      overlay: false,
      // オーバーレイを出す必要があるか
      error: null,
      // エラーオブジェクト
      reason: "",
      // エラー、オーバーレイの事由
      resumePoint: null,
      // 再生を開始する秒数
      entitlementConfirmed: false,
      // 権利の行使を確認したか
      watchOnBrowserFlag: meta.adultFlag ? true : false // 「ブラウザで見る」を選択したかどうか

    };
  }, [meta.adultFlag]);
  var reducer = useCallback(function (state, action) {
    switch (action.type) {
      case "update":
        return _objectSpread(_objectSpread({}, state), action.payload);

      case "overlay":
        return _objectSpread(_objectSpread({}, state), {}, {
          canplay: false,
          loading: false,
          prepared: false,
          overlay: true
        }, action.payload);

      case "canplay":
        return _objectSpread(_objectSpread({}, state), {}, {
          loading: false,
          canplay: true,
          overlay: false,
          error: null,
          reason: ""
        });

      case "resetAndUpdate":
        return _objectSpread(_objectSpread({}, initialState), {}, {
          loading: false,
          watchOnBrowserFlag: state.watchOnBrowserFlag
        }, action.payload);

      case "reset":
        return initialState;

      default:
        return state;
    }
  }, [initialState]);

  var _useReducer = useReducer(reducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var client = useApolloClient();

  var _useAuthUserQuery = useAuthUserQuery(),
      data = _useAuthUserQuery.data;

  var user = data === null || data === void 0 ? void 0 : data.user;

  var _useDeviceInfoQuery = useDeviceInfoQuery({
    fetchPolicy: "cache-first"
  }),
      _useDeviceInfoQuery$d = _useDeviceInfoQuery.data;

  _useDeviceInfoQuery$d = _useDeviceInfoQuery$d === void 0 ? {} : _useDeviceInfoQuery$d;
  var deviceInfo = _useDeviceInfoQuery$d.deviceInfo; //分割代入

  var _usePlaybackSessionOp = usePlaybackSessionOpenMutation(),
      _usePlaybackSessionOp2 = _slicedToArray(_usePlaybackSessionOp, 2),
      loadPlaybackSessionOpen = _usePlaybackSessionOp2[0],
      _usePlaybackSessionOp3 = _usePlaybackSessionOp2[1],
      sessionError = _usePlaybackSessionOp3.error,
      sessionData = _usePlaybackSessionOp3.data;

  var _usePlaybackSessionCl = usePlaybackSessionCloseMutation(),
      _usePlaybackSessionCl2 = _slicedToArray(_usePlaybackSessionCl, 1),
      sessionCloseMutation = _usePlaybackSessionCl2[0];

  var sessionClose = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _playbackAuth$current;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(playbackAuth.current && (_playbackAuth$current = playbackAuth.current) !== null && _playbackAuth$current !== void 0 && _playbackAuth$current.playback_session_id)) {
              _context.next = 4;
              break;
            }

            _context.next = 3;
            return sessionCloseMutation({
              variables: {
                sessionId: playbackAuth.current.playback_session_id
              },
              onError: function onError(e) {
                console.error("sessionCloseMutation error", e);
              }
            });

          case 3:
            playbackAuth.current = null;

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [(_playbackAuth$current2 = playbackAuth.current) === null || _playbackAuth$current2 === void 0 ? void 0 : _playbackAuth$current2.playback_session_id]);
  var standWatchOnBrowserFlag = useCallback(function () {
    dispatch({
      type: "resetAndUpdate",
      payload: {
        loading: false,
        watchOnBrowserFlag: true
      }
    });
  }, []); // resumePointを更新

  var updateResumePoint = useCallback(function (resumePoint) {
    dispatch({
      type: "resetAndUpdate",
      payload: {
        loading: false,
        resumePoint: resumePoint
      }
    });
  }, []); // 権利行使確認

  var entitlementConfirm = useCallback(function () {
    dispatch({
      type: "resetAndUpdate",
      payload: {
        loading: false,
        entitlementConfirmed: true
      }
    });
  }, []); // 処理の中断

  var prepareSuspend = useCallback(function () {
    dispatch({
      type: "resetAndUpdate",
      payload: {
        loading: false,
        prepared: true
      }
    });
  }, []); // 再生開始の再確認

  var prepareReconfirm = useCallback(function () {
    dispatch({
      type: "update",
      payload: {
        loading: false,
        prepared: true,
        reason: "entitlement_reconfirm",
        overlay: false,
        canplay: true
      }
    });
  }, []); // リセット

  var reset = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return sessionClose();

          case 2:
            mediaSource.current = null;
            playbackAuth.current = null;
            dispatch({
              type: "reset"
            });

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), []); // 再生可能

  var canplay = useCallback(function () {
    dispatch({
      type: "canplay"
    });
  }, []); // state のupdate

  var update = useCallback(function (payload) {
    dispatch({
      type: "update",
      payload: payload
    });
  }, []); // オーバーレイの表示

  var displayOverlay = useCallback(function (payload) {
    dispatch({
      type: "overlay",
      payload: payload
    });
  }, []); // 視聴許可判定

  var execPlaybackAuth = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var _playbackAuth$current3;

    var vuid, psId, _yield$client$query, data, error;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getVisitorId();

          case 2:
            vuid = _context3.sent;
            // playback_session_idを渡すと同一端末で同時視聴制限がかかってしまうのを防げるっぽい
            // どういうときにそういう状況になるか考えて値の保存の仕方を考えた方が良さそう
            // paraviはcookieに保存していたけど、cookieはあまり使いたくない
            psId = (_playbackAuth$current3 = playbackAuth.current) === null || _playbackAuth$current3 === void 0 ? void 0 : _playbackAuth$current3.playback_session_id;
            playbackAuth.current = null;
            _context3.next = 7;
            return client.query({
              query: GET_PLAYBACK,
              fetchPolicy: "network-only",
              variables: {
                id: parseInt(meta.id, 10),
                vuid: vuid,
                sessionId: psId,
                fl: user && user.test_flg ? 1 : 0
              }
            });

          case 7:
            _yield$client$query = _context3.sent;
            data = _yield$client$query.data;
            error = _yield$client$query.error;

            if (data) {
              playbackAuth.current = data.playbackAuth;
            } else if (error) {
              displayOverlay({
                reason: "error",
                error: authError
              });
            }

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), [meta, user]);
  var prepareToPlay = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;

            if (!(state.prepared || !deviceInfo)) {
              _context4.next = 3;
              break;
            }

            return _context4.abrupt("return");

          case 3:
            _context4.next = 5;
            return checkMember(user, meta);

          case 5:
            _context4.next = 7;
            return checkAgeRestriction(user, meta);

          case 7:
            if (playbackAuth.current) {
              _context4.next = 12;
              break;
            }

            _context4.next = 10;
            return checkUseEntitlement(state.entitlementConfirmed, entitlements);

          case 10:
            _context4.next = 12;
            return execPlaybackAuth();

          case 12:
            if (!playbackAuth.current) {
              _context4.next = 28;
              break;
            }

            _context4.next = 15;
            return checkPlaybackError(playbackAuth.current);

          case 15:
            _context4.next = 17;
            return checkMobileDevice(deviceInfo, meta.adultFlag);

          case 17:
            _context4.next = 19;
            return checkArea(user, meta, deviceInfo);

          case 19:
            _context4.next = 21;
            return checkMobileOS(deviceInfo, state.watchOnBrowserFlag, liveResumeFlag);

          case 21:
            _context4.next = 23;
            return checkLiveBefore(meta);

          case 23:
            _context4.next = 25;
            return checkDVRLive(meta, state.resumePoint);

          case 25:
            _context4.next = 27;
            return checkResume(state.resumePoint, playbackAuth.current, liveResumeFlag, updateResumePoint, resumepoint);

          case 27:
            update({
              prepared: true
            });

          case 28:
            _context4.next = 33;
            break;

          case 30:
            _context4.prev = 30;
            _context4.t0 = _context4["catch"](0);

            //上のcheckMobileDeviceとかの返り値としてthrowで投げられるエラーオブジェクトはここでcatchする
            //cathchしたe.reasonに応じたdisplayOverlayを実行する
            if (_context4.t0 instanceof PrepareToPlayOverlay) {
              displayOverlay({
                reason: _context4.t0.reason
              });
            } else {
              sessionClose();

              if (_context4.t0 instanceof PlaybackError) {
                if (deviceInfo !== null && deviceInfo !== void 0 && deviceInfo.isAndroid && _context4.t0.reason === "not_delivery_started" && !meta.adultFlag) {
                  displayOverlay({
                    reason: "appkick"
                  });
                } else {
                  displayOverlay({
                    reason: "playback_error",
                    error: _context4.t0
                  });
                }
              } else if (_context4.t0 instanceof GeoLocationError) {
                displayOverlay({
                  reason: "geolocation",
                  error: _context4.t0
                });
              } else {
                console.log(_context4.t0);
                displayOverlay({
                  reason: "error",
                  error: _context4.t0
                });
              }
            }

          case 33:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 30]]);
  })), [user, meta, entitlements, state, playbackAuth.current, liveResumeFlag, updateResumePoint, deviceInfo]); // load playbackSession

  useEffect(function () {
    var _playbackAuth$current4;

    if (state.prepared && playbackAuth.current && !((_playbackAuth$current4 = playbackAuth.current) !== null && _playbackAuth$current4 !== void 0 && _playbackAuth$current4.error) && !mediaSource.current && !sessionError) {
      var _playbackAuth$current5, _playbackAuth$current6, _playbackAuth$current7;

      loadPlaybackSessionOpen({
        variables: {
          videoId: (_playbackAuth$current5 = playbackAuth.current) === null || _playbackAuth$current5 === void 0 ? void 0 : (_playbackAuth$current6 = _playbackAuth$current5.media) === null || _playbackAuth$current6 === void 0 ? void 0 : _playbackAuth$current6.ovp_video_id,
          sessionId: (_playbackAuth$current7 = playbackAuth.current) === null || _playbackAuth$current7 === void 0 ? void 0 : _playbackAuth$current7.playback_session_id
        }
      });
    }
  }, [state.prepared, playbackAuth.current, mediaSource.current, sessionError]); // set playback media

  useEffect(function () {
    if (sessionData) {
      var _sessionData$playback;

      if ((_sessionData$playback = sessionData.playbackSessionOpen) !== null && _sessionData$playback !== void 0 && _sessionData$playback.error) {
        displayOverlay({
          reason: "error",
          error: new PlaybackSessionError(sessionData.playbackSessionOpen.error.message, sessionData.playbackSessionOpen.error.code)
        });
      } else {
        mediaSource.current = sessionData.playbackSessionOpen.media;
        canplay();
      }
    } else if (sessionError) {
      displayOverlay({
        reason: "error",
        error: sessionError
      });
    }
  }, [sessionError, sessionData]); // ページ離脱時にsessionClose

  useEffect(function () {
    var _playbackAuth$current8;

    // 依存配列に変化があるとクリーンナップ関数が実行されるため、それを防止する
    if (!deviceInfo || !((_playbackAuth$current8 = playbackAuth.current) !== null && _playbackAuth$current8 !== void 0 && _playbackAuth$current8.playback_session_id)) {
      return null;
    }

    var closed = false;

    var close = function close() {
      if (closed) {
        return;
      }

      closed = true;
      sessionClose();
    }; //iOSとMacのSafariの場合


    var isIOS = maybeIOS(deviceInfo);

    if (isIOS || deviceInfo !== null && deviceInfo !== void 0 && deviceInfo.isMac && deviceInfo !== null && deviceInfo !== void 0 && deviceInfo.isSafari) {
      window.addEventListener("pagehide", close);
      router.beforePopState(function (_ref5) {
        var url = _ref5.url,
            as = _ref5.as,
            options = _ref5.options;
        return close;
      });
      return function () {
        window.removeEventListener("pagehide", close);
        router.beforePopState(function () {
          return true;
        });

        if (!closed) {
          close();
        }
      };
    } //それ以外の場合
    else {
      window.addEventListener("beforeunload", close);
      return function () {
        window.removeEventListener("beforeunload", close);

        if (!closed) {
          close();
        }
      };
    }
  }, [deviceInfo, (_playbackAuth$current9 = playbackAuth.current) === null || _playbackAuth$current9 === void 0 ? void 0 : _playbackAuth$current9.playback_session_id]);
  return [prepareToPlay, _objectSpread(_objectSpread({}, state), {}, {
    playbackAuth: playbackAuth.current,
    mediaSource: mediaSource.current,
    updateResumePoint: updateResumePoint,
    entitlementConfirm: entitlementConfirm,
    displayOverlay: displayOverlay,
    reset: reset,
    prepareSuspend: prepareSuspend,
    prepareReconfirm: prepareReconfirm,
    standWatchOnBrowserFlag: standWatchOnBrowserFlag
  })];
}